import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { useRecentOrdersQuery } from '../api/queries/useRecentOrdersQuery'
import { isClosedStatus } from '../constants/orderStatus'

export interface OfferingOrderRef {
  orderId: string
  orderReference: string
  displayStatus: string
}

/**
 * The order behind a holding: the newest order for this offering that wasn't
 * rejected, cancelled or deleted. The holdings API doesn't carry it, so it is
 * looked up in the first history page (newest 50). Null when none matches.
 */
export function useOfferingOrder(offeringId: MaybeRefOrGetter<string>) {
  const ordersQuery = useRecentOrdersQuery(() => Boolean(toValue(offeringId)))

  const order = computed<OfferingOrderRef | null>(() => {
    const id = toValue(offeringId)
    const match = (ordersQuery.data.value ?? []).find(
      (row) => row.offeringId === id && !isClosedStatus(row.displayStatus),
    )
    return match
      ? { orderId: match.id, orderReference: match.trackingId, displayStatus: match.displayStatus }
      : null
  })

  return { order }
}
